/**
 * How far a ground decal floats above the floor it is drawn on.
 *
 * Three files each had their own: `Telegraphs` 0.06, `StatusAura` 0.04,
 * `AimReticle` 0.03 — and the two newer ones BOTH carried a comment saying
 * "the same epsilon the other decals use". Neither matched, and neither matched
 * the original. The comments were documenting a convention that did not exist.
 *
 * It matters because it is one number doing one job: lift a coplanar quad far
 * enough off the deck to win the depth test, without lifting it so far that it
 * visibly hovers or clips through a body standing on it. A telegraph, a status
 * ring and a reach reticle drawn at three different heights z-fight each other
 * where they overlap — which is at the caster's feet, where all three are at
 * once.
 */
export const DECAL_LIFT = 0.06;

/**
 * The extra nudge for a decal drawn ON TOP of another decal — a fill over its
 * own rim, say. Small enough to be invisible, large enough to order them.
 */
export const DECAL_STACK = 0.02;
